import CartCheckoutHOC from '@common/components/CartCheckoutHOC';
import { RootState } from '@common/store';
import {
  addProductToCart,
  // addPromoCodeToCart,
  CartSliceType,
  removeProductFromCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import history from '@common/utils/history';
import CartImg from '@images/Cart.svg';
import Close from '@images/Close.svg';
import Rupee from '@instamojo/rupee';
// import Link from '@lib/Link';
import React from 'react';
import { connect } from 'react-redux';

import CartItem from './CartItem';

export interface CartProps {
  className?: string;
  setShowQuickCart?: () => void;
  cart: CartSliceType;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  removeProductFromCart: typeof removeProductFromCart;
  // addPromoCodeToCart: typeof addPromoCodeToCart;
  storeType: string;
}

const Cart: React.FunctionComponent<CartProps> = ({
  cart,
  addProductToCart,
  subtractProductFromCart,
  removeProductFromCart,
  setShowQuickCart,
  // recentlyViewed,
}) => {
  return (
    <CartCheckoutHOC
      render={({ products, totalAmount, cartHasOptionProduct, cartHasVariant }) => {
        const prods = Object.values(cart.products);
        const totalProducts = prods.reduce((sum, prod) => sum + prod.cartQuantity, 0);

        return (
          <div className="">
            <div className="">
              <div className="md:flex md:flex-wrap md:justify-between h-full">
                <div className="w-full overflow-y-scroll pl-17 pr-14">
                  <div className="flex justify-between items-center md:my-42 mb-16 pt-20 px-3">
                    <img
                      src={Close}
                      alt=""
                      onClick={() => {
                        setShowQuickCart();
                      }}
                    />
                    <div className="text-24 leading-26 font-semibold text-title">Quick Cart</div>
                    <div className="flex flex-col relative items-center mr-8">
                      <button
                        onClick={() => {
                          history.push('/cart');
                        }}
                      >
                        <img src={CartImg} alt="Cart" className="h-24 lg:h-16 m-auto" />
                        {totalProducts ? (
                          <div className="bg-theme bg-opacity-50 p-2 top-m17 right-m13 leading-21 text-12 font-medium text-black rounded-full text-center w-24 h-24 absolute">
                            {totalProducts}
                          </div>
                        ) : null}
                      </button>
                    </div>
                  </div>
                  <div className="h-60v md:h-80v mt-10 overflow-y-scroll">
                    {products.map((product) => (
                      <div
                        key={product.hash}
                        className="py-30 border-grayBorder border-t-0 border-r-0 border-l-0 border-b last:mb-200"
                      >
                        <CartItem
                          product={product}
                          addProductToCart={addProductToCart}
                          subtractProductFromCart={subtractProductFromCart}
                          removeProductFromCart={removeProductFromCart}
                          cartHasOptionProduct={cartHasOptionProduct}
                          cartHasVariant={cartHasVariant}
                          cartProductQuantity={cart?.quantityByProductId[product.id] || 0}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="absolute bottom-0 w-full bg-white">
                  <div className="md:pb-14 pb-16 py-10 md:py-14 px-19 md:px-20 ">
                    <div className="flex mb-10" font-customisation="para-text">
                      <p className="w-1/2 text-text_variant md:text-20 md:leading-26 text-18 leading-22 font-normal">
                        Sub Total
                      </p>
                      <p className="w-1/2 text-right text-title font-extrabold md:text-24 md:leading-28 text-20 leading-22">
                        <Rupee className="" value={totalAmount} />
                      </p>
                    </div>
                    <button
                      onClick={() => {
                        history.push('/cart');
                      }}
                      className="mt-4 md:mt-10 no-defaults font-medium text-16 leading-22 bg-theme rounded-full text-white px-10 h-48 w-full justify-center items-center hover:bg-themeHover focus:bg-themeFocus"
                      button-customisation="page-button"
                      font-customisation="para-text"
                    >
                      View Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default connect(
  ({ cart }: RootState) => ({
    cart,
  }),
  {
    addProductToCart,
    removeProductFromCart,
    subtractProductFromCart,
  },
)(Cart);
